import React from "react";
import "./swiperText.scss";

function SwiperText() {
  return (
    <>
      <div className="swiperText">
        <h3>Meaningful Giving Made Easy</h3>
      </div>
    </>
  );
}

export default SwiperText;
